import PropTypes from 'prop-types'
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'

const FieldInputPhoneNumber = (props) => {
    const {
        id,
        iconBefore,
        iconAfter,
        wrapperClasses,
        field,
        form: {touched, errors, setFieldValue}
    } = props;

    const styles = {
      buttonStyle: {
        right: 15,
        border: 0,
        background: "none",
        position: "absolute",
      },
      inputStyle: {
        border: 0,
        paddingLeft: 0,
        width: "150px",
      },
      dropdownStyle: {
        width: "240px",
        textAlign: "left",
        marginLeft: "-200px",
        marginTop: "15px",
      },
    };

    const handleKeyDown = (e) => {
      // Prevent backspace/delete when cursor is at the start of the input
      // or when trying to delete the country code
      if (['Backspace', 'Delete'].includes(e.key)) {
        const input = e.target;
        const currentValue = input.value;
        const selectionStart = input.selectionStart;
        
        // Get the current country dial code length (e.g., "+91" is 3 characters)
        const dialCodeLength = currentValue.match(/^\+\d+/)?.[0]?.length || 0;
        
        if (
          (e.key === 'Backspace' && selectionStart <= dialCodeLength) ||
          (e.key === 'Delete' && selectionStart < dialCodeLength)
        ) {
          e.preventDefault();
        }
      }
    };

    return (
      <div className={"mb-5 " + wrapperClasses}>
        <div className="field input-group flex py-2 mb-2 shadow">
          {iconBefore && (
            <span className="flex items-center justify-center text-gray-400	">
              {iconBefore}
            </span>
          )}
          <ReactPhoneInput
            {...field}
            id={id}
            buttonStyle={styles.buttonStyle}
            inputStyle={styles.inputStyle}
            dropdownStyle={styles.dropdownStyle}
            onChange={(number, country) => {
              setFieldValue(field.name, number);
              setFieldValue("countryCode", country.countryCode);
              setFieldValue("countryDial", country.dialCode);
            }}
            onKeyDown={handleKeyDown}  // Add this line
            enableSearch={true}
            country={"in"}
          />
          {iconAfter && (
            <span className="flex items-center justify-center text-gray-400	">
              {iconAfter}
            </span>
          )}
        </div>
        {touched[field.name] && (
          <p className="text-red-500 text-xs italic">{errors[field.name]}</p>
        )}
      </div>
    );
}

export default FieldInputPhoneNumber

FieldInputPhoneNumber.propTypes = {
    type: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    iconBefore: PropTypes.element,
    iconAfter: PropTypes.element,
    field: PropTypes.object,
    form: PropTypes.object,
    max: PropTypes.string,
    disabled: PropTypes.string,
    wrapperClasses: PropTypes.string,
    inputClasses: PropTypes.string,
    onChange: PropTypes.func,
}